var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.27 4.81a1.362 1.362 0 0 0-1.366 1.357v7.509a1.36 1.36 0 0 0 1.367 1.367 1.361 1.361 0 0 0 1.359-1.367V6.167a1.362 1.362 0 0 0-1.36-1.356zm-16.083 5.578a1.362 1.362 0 0 0-.965 2.322l5.309 5.32a1.36 1.36 0 0 0 1.93 0 1.363 1.363 0 0 0 0-1.931l-5.32-5.31a1.362 1.362 0 0 0-.954-.4zm10.352 10.304a1.362 1.362 0 0 0-1.365 1.73l7.65 27.685a1.361 1.361 0 0 0 2.484.333l4.504-7.66 6.231 6.231a1.362 1.362 0 0 0 1.92 0l5.48-5.479a1.362 1.362 0 0 0 0-1.92l-6.293-6.293 7.7-4.432a1.362 1.362 0 0 0-.311-2.495l-27.686-7.65a1.362 1.362 0 0 0-.314-.05zm-15.94 5.78A1.362 1.362 0 0 0 4.64 28.8c.254.254.599.398.959.4h7.508a1.36 1.36 0 0 0 1.265-1.884 1.362 1.362 0 0 0-1.265-.843H5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.3d77aee886fc3d6799bd0009c2d008a4.svg";
export { ForwardRef as ReactComponent };